module.exports = __webpack_public_path__ + "static/globus-5a80f6d018ccf00db76e9e984e54e3ad.png";